<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('series.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('series.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'live-streaming-series' }">{{ $t('series.livestream-list.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-nav pills fill>
          <b-nav-item :to="{ name: 'live-streaming-series' }" active>{{ $t('series.livestream-list.title') }}</b-nav-item>
          <b-nav-item :to="{ name: 'ongoing-series' }">{{ $t('series.list.title') }}</b-nav-item>
        </b-nav>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row">
        <div class="col">
          <b-dropdown class="m-2" :text="label_of_dropdown">
            <b-dropdown-item
              v-for="(label, index) in days_of_week"
              @click.native="selectDayOfWeek(index)"
            >{{ label }}</b-dropdown-item>
          </b-dropdown>
          <b-button class="m-2" :to="{ name: 'all-live-streaming-series' }">{{ $t('series.livestream-list.all.title') }}</b-button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-table
            fixed
            striped
            stacked="sm"
            :fields="fields"
            :items="courses"
            :sort-by.sync="ordering"
          >
            <template #cell(time)="data">
              <span class="text-danger d-inline-block" v-if="data.item.enddate && data.item.enddate.substr(0, 10) === data.item.spkdate.substr(0, 10)">
                {{ data.item.spkdate.substr(0, 10) }}&nbsp;
              </span>
              <span class="text-danger d-inline-block" v-else>
                {{ getHumanReadableForWeekNumber(data.item.week_number) }}&nbsp;
              </span>
              <span class="text-danger d-inline-block">
                {{ days_of_week[data.item.week == 7 ? 0 : data.item.week] }}&nbsp;
              </span>
              <span class="text-danger d-inline-block">
                {{ data.item.spk_start_time }} ~ {{ data.item.spk_end_time }}
              </span>
            </template>
            <template #cell(title_full_name)="data">
              <a href="javascript:void(0)" @click="showCourseInfo(data.item)">{{ data.value }}</a>
            </template>
            <template #cell(lecturer)="data">
              <a href="javascript:void(0)" @click="showLecturerInfo(data.value)">
                {{ data.value.lecr_full_name }}
              </a>
            </template>
            <template #cell(spkdate)="data">
              {{ data.value.substr(0, 10) }}
            </template>
            <template #cell(livestream_url)="data">
              <b-button
                variant="primary"
                @click="showCourseLiveStreaming(data.item)"
                v-if="hasStarted(data.item)"
              >
                {{ $t('series.livestream-list.button.livestream.label') }} <b-icon icon="play"></b-icon>
              </b-button>
              <span v-else>{{ $t('series.livestream-list.message.have-not-started-yet') }}</span>
            </template>
          </b-table>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
    <info-modal id="course-info" :title="$t('course.detail.title')">
      <template #info>
        <course-info :course="course"></course-info>
      </template>
    </info-modal>
    <info-modal id="lecturer-info" :title="$t('lecturer.detail.title')">
      <template #info>
        <lecturer-info :lecturer="lecturer"></lecturer-info>
      </template>
    </info-modal>
    <b-modal
      centered
      size="lg"
      id="course-live-streaming"
      :title="course ? course.title_full_name : ''"
    >
      <live-streaming-player :source="course_live_streaming_url"></live-streaming-player>       
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { DropdownPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'

import CourseInfo from '@/components/info/CourseInfo'
import LecturerInfo from '@/components/info/LecturerInfo'
import InfoModal from '@/components/modals/InfoModal.vue'
import LiveStreamingPlayer from '@/components/players/LiveStreamingPlayer'
import i18n from '@/plugins/i18n.js'
import CourseApiService from '@/services/budaedu-api-services/course-api-service.js'
import LecturerApiService from '@/services/budaedu-api-services/lecturer-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(DropdownPlugin)
Vue.use(IconsPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)
Vue.use(OverlayPlugin)
Vue.use(TablePlugin)

Vue.use(CourseApiService)
Vue.use(LecturerApiService)

export default {
  i18n,
  name: 'live-streaming-series',
  data() {
    return {
      is_loading: false,
      label_of_dropdown: '',
      day_of_week: new Date().getDay(),
      courses: [],
      course: null,
      course_live_streaming_url: '',
      lecturer: null,
      lecturer_photo: null,
      ordering: 'spk_start_time'
    }
  },
  computed: {
    numbers_of_week() {
      return {
        '-5': this.$t('frequency.week-intervals.five'),
        '-4': this.$t('frequency.week-intervals.four'),
        '-3': this.$t('frequency.week-intervals.three'),
        '-2': this.$t('frequency.week-intervals.two'),
        '-1': this.$t('frequency.week-intervals.one'),
        '0': this.$t('frequency.weekly'),
        '1': this.$t('frequency.weeks-of-month.first'),
        '2': this.$t('frequency.weeks-of-month.second'),
        '3': this.$t('frequency.weeks-of-month.third'),
        '4': this.$t('frequency.weeks-of-month.fourth'),
        '5': this.$t('frequency.weeks-of-month.fifth')
      }
    },
    days_of_week() {
      return [
        this.$t('days-of-week.sunday.full'),
        this.$t('days-of-week.monday.full'),
        this.$t('days-of-week.tuesday.full'),
        this.$t('days-of-week.wednesday.full'),
        this.$t('days-of-week.thursday.full'),
        this.$t('days-of-week.friday.full'),
        this.$t('days-of-week.saturday.full')
      ]
    },
    fields() {
      return [
        { key: 'time', label: this.$t('series.livestream-list.table.header.time') },
        { key: 'title_full_name', label: this.$t('series.livestream-list.table.header.course') },
        { key: 'lecturer', label: this.$t('series.livestream-list.table.header.lecturer') },
        { key: 'spkdate', label: this.$t('series.livestream-list.table.header.start-date') },
        { key: 'livestream_url', label: this.$t('series.livestream-list.table.header.livestream') },
        { key: 'remark', label: this.$t('series.livestream-list.table.header.remark') }
      ]
    }
  },
  methods: {
    getTodayDateString() {
      const today = new Date();
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const date = today.getDate()
      return `${year}-${month < 10 ? `0${month}` : month}-${date < 10 ? `0${date}` : date}`
    },
    selectDayOfWeek(day_of_week) {
      this.day_of_week = day_of_week
      this.label_of_dropdown = this.days_of_week[this.day_of_week]
      this.setCourses()
    },
    hasStarted(course) {
      return course.spkdate.substr(0, 10) <= this.getTodayDateString()
    },
    getHumanReadableForWeekNumber(week_number) {
      let return_value = week_number
        .map(item => this.numbers_of_week[item])
        .join('、')
      return return_value
    },
    allNotEqualToZero(week_number) {
      return week_number.every(item => parseInt(item) != 0)
    },
    showCourseInfo(course) {
      this.course = course
      this.$nextTick(function () {
        this.$bvModal.show('course-info')
      });
    },
    async showLecturerInfo(lecturer) {
      const item = await this.$lecturerApiService.getPhoto(lecturer)
      lecturer.photo = item ? item.data : {}
      this.lecturer = lecturer
      this.$nextTick(function () {
        this.$bvModal.show('lecturer-info')
      });
    },
    showCourseLiveStreaming(course) {
      this.course = course
      this.course_live_streaming_url = this.getLivestreamUrl(course.places)
      this.$bvModal.show('course-live-streaming')

      gtag('event', `watch course live`, {
        code: this.course.id,
        name: this.course.title_full_name,
      })
    },
    getLivestreamUrl(places) {
      let livestream_place = places.filter(
        item => item.pivot.live === 'Y'
          && item.live_url !== ''
          && item.live_url !== null
          && item.live_url !== undefined
      ).shift();

      return livestream_place !== undefined ? livestream_place.live_url : '';
    },
    async setCourses() {
      this.is_loading = true
      this.courses = []
      try {
        const items = await this.$courseApiService.queryHaveLiveStreamOnDayOfWeek(
          this.day_of_week,
          'include=places&order=spk_start_time,asc|spk_end_time,asc'
        )
        this.courses = items.data
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`);
    await this.setCourses()
    this.label_of_dropdown = this.days_of_week[this.day_of_week]
  },
  components: {
    CourseInfo,
    InfoModal,
    LecturerInfo,
    LiveStreamingPlayer
  },
  metaInfo() {
    return {
      title: `${this.$t('series.livestream-list.title')}`,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>